
import { Vue, Component, Prop } from "vue-property-decorator";
import { regionData } from "element-china-area-data";
@Component({
  name: "orderDetail",
})	
export default class orderDetail extends Vue {
	
  private tableData: Array<any> = [];
  private form =  {};
  private tempData = {};
  data() {
    return {
		url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
		value: [[17,18,19],[1,7,10],[1,2,3]],
		options : regionData,
		selectedOptions:[],
		radio: '2'
	}
  };
  private onCancel(){
	  
	  console.log('取消')
	  this.$router.back();
  }
  private onSubmit() {
    console.log(this.tempData);

  };
  private handleUrge(value:any){
	  
	  console.log('ddd',value);
  };
  private mounted(){
	  
	  this.tempData = this.$route.params;
	  console.log('ddd',this.tempData);
	  let paramArray:any = this.$route.params.tasteVos;
	  paramArray.map(item=>{
	  		
		this.tableData.push(item.tasteVo)
	  });
  }
}
	
